import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { LocationBackModel, LocationState } from '../../types/location-state';

interface useGetLocationStateProps {
    getLocationState: () => { back: LocationBackModel[] };
}

const useGetLocationState = (text: string): useGetLocationStateProps => {
    const location = useLocation<LocationState>();

    const handleClick = useCallback(() => {
        return {
            back: [
                ...(location.state?.back || []),
                {
                    link: `${location.pathname}${location.search}`,
                    text: text,
                },
            ],
        };
    }, [location, text]);

    return { getLocationState: handleClick };
};

export default useGetLocationState;
